import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Checkbox,
  CheckPicker,
  SelectPicker,
  Button,
  Notification,
  useToaster,
  Modal,
  DateRangePicker,
} from "rsuite";
import { Loader } from "../../components/common/Loader";
import {
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  YAxis,
  Bar,
  Line,
  LabelList,
  Tooltip,
  BarChart,
  Legend,
  Label,
  CartesianGrid,
  ReferenceLine,
  Scatter,
  LineChart,
} from "recharts";
import {
  getValueCaptureFilters,
  getValueCaptureMarginImprovementOverview,
  getValueCaptureGraphData,
  getValueCaptureMarginGraphData,
  getValueCaptureExportData,
} from "../../queries/apiQueries";
import { numberFormatter } from "../../utils";
import { leakageTimelineOptions } from "../constants";
import "./marginPreservation.scss";
import MarginImprovement from "./marginImprovement";
import NetCostReductionChart from "./netCostReductionChart";
import PricingExecution from "./pricingExecution";
import { appInsights } from "../router";
import { margin } from "@mui/system";
import moment from "moment";
import MainHeader from "../../components/Layouts/MainHeader";
import { Segmented } from "antd";
import MainContent from "../../components/Layouts/MainContent";
import FileDownloadIcon from "@rsuite/icons/FileDownload";
import { CSVLink } from "react-csv";
import GreenUpArrow from "../../assets/expand-menu.svg";

const MarginPreservationDashboard = (props: any) => {
  const dispatch = useDispatch<any>();
  var isCleared = false;
  const didClear: any = useRef(false);
  const toaster = useToaster();

  const implementedTabs: any = [
    "SALES",
    "NIA IMPROVEMENT",
    "REALISED BENEFITS",
    "PROJECTED ANNUAL BENEFITS",
  ];

  const [activeTab, setActiveTab] = useState("margin");
  const [filterOptions, updateFilterOptions] = useState<any>({
    district: new Array<{ district: string }>(),
    supplier: new Array<{ supplier: string }>(),
    valueCapture_l3: new Array<{ valueCapture_l3: string }>(),
  });
  const allFilters = useSelector(
    (state: any) => state.CommonReducer.allFilters
  );
  const [selectedFilters, setSelectedFilters] = useState<any>({
    ...allFilters,
    valueCapture_l3: [],
  });
  const filtersMount: any = useRef(false);
  const [filtersLoading, setFiltersLoading] = useState(true);
  const [selectedTimeline, setSelectedTimeline] = useState<any>(
    leakageTimelineOptions[0].value
  );
  const [isLoading, setIsLoading] = useState(true);
  const [overviewData, setOverviewData] = useState<any>({});
  const [lineChartData, setLineChartData] = useState<any>([]);
  const [prePostLiveData, setPrePostLiveData] = useState<any>({});
  const [export1Data, setExport1Data] = useState<any>([]);
  const [export2Data, setExport2Data] = useState([]);
  const [pricingExportData, setPricingExportData] = useState([]);
  const [lineChartDataCopy, setLineChartDataCopy] = useState<any>([]);
  const [minMax, setMinMax] = useState({ min: 0, max: 0 });
  const [graphData, setGraphData] = useState<Array<any>>([]);
  const [graphData2, setGraphData2] = useState<Array<any>>([]);
  const [goLiveDate, setGoLiveDate] = useState<Array<any>>([]);
  const [bpsGraphData, setBpsGraphData] = useState<any>([]);
  const [bpsData, setBpsData] = useState<any>({ positive: 0, negative: 0 });
  const [marginBelowRef, setMarginfBelowRef] = useState(false);
  const [showProjectedYear, setShowProjectedYear] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState(null);
  const [range, setRange] = useState([null, null]);
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isRightVisible, setIsRightVisible] = useState(false);
  const [timelineObject, setTimelineObject] = useState<{
      baseline: number;
      current: number;
      }>({ baseline: 2025, current: 2026 });

  const token = useSelector((state: any) => state.CommonReducer.token);
  const exportFullRef = useRef<any>(null);
  const exportFullRef2 = useRef<any>(null);
  const exportFullRef3 = useRef<any>(null);

  const didMount: any = useRef(false);

  useEffect(() => {
    appInsights.trackPageView({
      name: `Navigate to Margin preservation dashboard by ${localStorage.getItem(
        "user_name"
      )}, ${localStorage.getItem("user_email")}`,
    });
    if (token) {
      getFilters();
      getMarginData();
      getGraphData();
      getGraphDataSet2();
    }
  }, [token]);

  useEffect(() => {
    if (export2Data?.length !== 0) {
      exportFullRef2?.current?.link.click();
    }
  }, [export2Data]);

  useEffect(() => {
    if (pricingExportData?.length !== 0) {
      exportFullRef3?.current?.link.click();
    }
  }, [pricingExportData]);

  const csvHeaders = [
    { label: "Category", key: "Category" },
    { label: "Supplier", key: "Supplier" },
    { label: "District", key: "District" },
    { label: "Net Cost", key: "cost" },
    { label: "Sales $", key: "sales" },
    { label: "Month", key: "month" },
    { label: "Year", key: "year" },
    { label: "GM%", key: "gm" },
    { label: "Net Cost Reduction", key: "netCostRed" },
    { label: "Margin Benefit $", key: "margin" },
    { label: "Leakage $", key: "leakage" },
    { label: "GM% wo Leakage", key: "marginWoLeakage" },
  ];

  const csvHeaders2 = [
    { label: "Week start date", key: "week_start_month" },
    { label: "Vendor", key: "master_vendor_name" },
    { label: "Category", key: "valueCapture_l3" },
    { label: "Go-Live Date", key: "golive_date" },
    { label: "Cost ($/Unit) 2024", key: "costperunit2024" },
    { label: "Cost ($/Unit) 2025", key: "costperunit2025" },
    { label: "Qty 2025", key: "qty2025" },
    { label: "Net cost'24", key: "netcost2024" },
    { label: "Net cost'25", key: "netcost2025" },
    { label: "Sell price ($/Unit) 2024", key: "sellpriceperunit2024" },
    { label: "Sell price ($/Unit) 2025", key: "sellpriceperunit2025" },
    { label: "Revenue 2025", key: "revenue2025" },
    { label: "Gross Margin% 2024", key: "gm2024" },
    { label: "Gross Margin% 2025", key: "gm2025" },
    { label: "Margin Improvement Benefit", key: "marginRevenue" },
    { label: "Month", key: "weekPartMonth" },
    { label: "Net Cost Reduction", key: "netCostRed" },
    { label: "Margin Benefit $", key: "margin" },
    { label: "Leakage $", key: "leakage" },
    { label: "GM% wo Leakage", key: "marginWoLeakage" },
  ];

  const csvHeaders3 = [
    { label: "Week of Sales Date ", key: "weekOfYear" },
    { label: "Sales Date", key: "daydate" },
    { label: "Master_Vendor_Name", key: "Master_Vendor_Name" },
    { label: "L3", key: "l3" },
    { label: "BILLING_DOCUMENT_VBELN", key: "BILLING_DOCUMENT_VBELN" },
    { label: "SALES_ITEM_POSNR", key: "SALES_ITEM_POSNR" },
    { label: "GBID", key: "MATERIAL_MATERIAL" },
    { label: "District", key: "District" },
    { label: "Sales_Office_VKBUR", key: "SALES_OFFICE_VKBUR" },
    { label: "SOLDTO_PARTY_ID", key: "customer" },
    { label: "SALES_REP_FINAL", key: "SALES_REP_FINAL" },
    {
      label: "BILLING_QTY_IN_SKU_FKLMG_W_RETURN",
      key: "BILLING_QTY_IN_SKU_FKLMG_W_RETURN",
    },
    { label: "SALES_W_RETURN", key: "SALES_W_RETURN" },
    {
      label: "Net Cost_SPA Adjusted ($/unit)",
      key: "Net_Cost_SPA_Adjusted_perUnit",
    },
    { label: "Sell Price ($/unit)", key: "Sell_Price_perUnit" },
    { label: "GM%", key: "GM" },
    { label: "TargetGMR", key: "TARGET_GMR" },
    { label: "FloorGMR", key: "FLOOR_GMR" },
    { label: "TARGET PRICE  ($/U)", key: "targetPrice" },
    { label: "FLOOR PRICE ($/U)", key: "FloorPrice" },
    { label: "Pricing Condition", key: "PRICING_COND_TYPE" },
    { label: "Manual Override", key: "OVERRIDE_FLAG" },
    { label: "ZZCOMBINED_GRD", key: "stratification" },
    { label: "ZZPEER_GROUP", key: "customerSize" },
    { label: "ZZMARKET", key: "customerMarket" },
    { label: "ZZSUB_MARKET", key: "customerSubMarket" },
  ];

  const exportDataClick = () => {
    if (export1Data?.length > 0) {
      exportFullRef?.current?.link.click();
    }
  };

  const handlePopUpClose = () => {
    setPopUp(false);
  };

  const handlePopUpConfirmClick = () => {
    pricingReportHandler();
    setPopUp(false);
  };

  const shouldDisableDate = (date: any) => {
    const today: any = fromDate ? new Date(fromDate[1]) : new Date();
    today.setHours(0, 0, 0, 0);
    const maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + 35);

    const candidate = new Date(date);
    candidate.setHours(0, 0, 0, 0);

    // Only allow dates from today to next 6 days
    return candidate <= today || candidate > maxDate;
  };

  /* Filters api call */
  const getFilters = async (
    payload: any = {},
    currentFilter: any = "all",
    fo: any = null
  ) => {
    setFiltersLoading(true);
    let res = await dispatch(getValueCaptureFilters(payload));
    let temp: any = [];
    // res.valueCapture_l3.map((item: any) => {
    //   if (item.valueCapture_l3 !== "Others (Eaton Specific)") {
    //     temp.push(item);
    //   }
    // });
    // res.valueCapture_l3 = temp;
    if (fo) {
      if (currentFilter === "valueCapture_l3") {
        updateFilterOptions({
          ...fo,
          supplier: [...res.master_vendor_name],
          district: [...res.district],
        });
      } else if (currentFilter === "supplier") {
        updateFilterOptions({
          ...fo,
          district: [...res.district],
        });
      } else if (currentFilter === "district") {
        updateFilterOptions({
          ...fo,
        });
      } else {
        updateFilterOptions({
          valueCapture_l3: res.valueCapture_l3,
          supplier: res.master_vendor_name,
          district: res.district,
        });
      }
    } else {
      if (currentFilter === "valueCapture_l3") {
        updateFilterOptions({
          ...filterOptions,
          supplier: [...res.master_vendor_name],
          district: [...res.district],
        });
      } else if (currentFilter === "supplier") {
        updateFilterOptions({
          ...filterOptions,
          district: [...res.district],
        });
      } else if (currentFilter === "district") {
        updateFilterOptions({
          ...filterOptions,
        });
      } else {
        updateFilterOptions({
          valueCapture_l3: res.valueCapture_l3,
          supplier: res.master_vendor_name,
          district: res.district,
        });
      }
    }

    // setIsLoading(false);
    setFiltersLoading(false);
    filtersMount.current = false;
    return res;
  };

  /* Updating filter selection state  */
  const handleFilterUpdate = (value: any, filter: string) => {
    if (isCleared) {
      isCleared = false;
      return;
    }
    filtersMount.current = true;
    let x: string = filter;
    if (value === "all") {
      if (filterOptions?.[x].length === selectedFilters?.[x].length) {
        setSelectedFilters({ ...selectedFilters, [x]: [] });
      } else {
        if (x == "supplier") {
          setSelectedFilters({
            ...selectedFilters,
            [x]: [
              ...filterOptions?.[x].map(
                (option: any) => option.master_vendor_name
              ),
            ],
          });
        } else {
          setSelectedFilters({
            ...selectedFilters,
            [x]: [...filterOptions?.[x].map((option: any) => option?.[x])],
          });
        }
      }
    } else {
      setSelectedFilters({ ...selectedFilters, [x]: [...value] });
    }
    didClear.current = true;
  };

  /* Updating filter options based on selection (api) */
  const handleClose = (filter: string) => {
    if (filter === "valueCapture_l3") {
      setSelectedFilters({ ...selectedFilters, supplier: [], district: [] });
      getFilters(
        { ...selectedFilters, supplier: [], district: [] },
        "valueCapture_l3"
      );
      getMarginData("", "valueCapture_l3");
      getGraphData("", "valueCapture_l3");
      getGraphDataSet2("", "valueCapture_l3");
    } else if (filter === "supplier") {
      setSelectedFilters({ ...selectedFilters, district: [] });
      getFilters({ ...selectedFilters, district: [] }, "supplier");
      getMarginData("", "supplier");
      getGraphData("", "supplier");
      getGraphDataSet2("", "supplier");
    } else if (filter === "district") {
      setSelectedFilters({ ...selectedFilters });
      getMarginData("", "district");
      getGraphData("", "district");
      getGraphDataSet2("", "district");
    }
    // setIsGraphLoading(true);
    // setIsGraph2Loading(true);
  };

  const handleClear = (filter: string) => {
    isCleared = true;

    didClear.current = true;
    if (filter === "valueCapture_l3") {
      setSelectedFilters({ valueCapture_l3: [], supplier: [], district: [] });
      getMarginData("valueCapture_l3");
      getGraphData("valueCapture_l3");
      getGraphDataSet2("valueCapture_l3");
      getFilters(
        { valueCapture_l3: [], supplier: [], district: [] },
        "valueCapture_l3"
      );
    } else if (filter === "supplier") {
      setSelectedFilters({ ...selectedFilters, supplier: [], district: [] });
      getMarginData("supplier");
      getGraphData("supplier");
      getGraphDataSet2("supplier");
      getFilters(
        { ...selectedFilters, supplier: [], district: [] },
        "supplier"
      );
    } else if (filter === "district") {
      getMarginData("district");
      getGraphData("district");
      getGraphDataSet2("district");
      setSelectedFilters({ ...selectedFilters, district: [] });
    }
  };

  const getMarginData = async (
    clearFilterFlag: any = null,
    filterSelected: any = null
  ) => {
    setIsLoading(true);
    let payload: any = {
      district: selectedFilters.district,
      valueCapture_l3: selectedFilters.valueCapture_l3,
      master_vendor_name: selectedFilters.supplier,
    };

    if (clearFilterFlag == "valueCapture_l3") {
      payload.valueCapture_l3 = [];
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (clearFilterFlag == "supplier") {
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (clearFilterFlag == "district") {
      payload.district = [];
    }

    if (filterSelected == "valueCapture_l3") {
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (filterSelected == "supplier") {
      payload.district = [];
    }

    let res = await dispatch(getValueCaptureMarginImprovementOverview(payload));

    if (res) {
      console.log(
        payload.valueCapture_l3?.length !== 0,
        payload.master_vendor_name?.length === 0
      );
      if (payload.master_vendor_name?.length === 0) {
        res?.finalData?.goLiveDate.sort(
          (a: any, b: any) =>
            new Date(a.golive_date).getTime() -
            new Date(b.golive_date).getTime()
        );
        setGoLiveDate(res?.finalData?.goLiveDate)
        if (payload.valueCapture_l3?.length !== 0) {
          res.finalData.goLiveDate = [
            {
              master_vendor_name: payload.valueCapture_l3[0],
              golive_date: res?.finalData?.goLiveDate[0]?.golive_date,
            },
          ];
        } else if (payload.valueCapture_l3?.length == 0) {
          res.finalData.goLiveDate = [
            {
              master_vendor_name: "Category Startegy",
              golive_date: res?.finalData?.goLiveDate[0]?.golive_date,
            },
          ];
        }

        setOverviewData(res.finalData);
      } else {
        console.log("not here");
        setOverviewData(res.finalData);
      }

      console.log(res, "res");
      let newData: any = [];
      res?.finalData?.lineChart?.map((item: any, i: any) => {
        newData.push({
          margin: item.margin * 100,
          monthStartDate: moment
            .utc(item.monthStartDate)
            .format(!item?.monthlyFlag ? `MMM DD` : `MMM'YY`),
          gmLeakageLabel:
            i == res?.finalData?.lineChart.length - 1
              ? Number(res.finalData["latestMonth"]?.gmWoLeakage) * 100
              : null,
        });
      });
      let flag: any = 0;
      newData.map((item: any) => {
        debugger
        if (flag == 0) {
          item.goLiveline1 =
            Number(res?.finalData?.preAndPostGoLiveData?.pre?.gm) * 100;
          item.goLivelineGreen = null;
        } else {
          item.goLiveline1 = null;
          if (
            Number(res?.finalData?.preAndPostGoLiveData?.pre?.gm) * 100 <=
            Number(res?.finalData?.preAndPostGoLiveData?.post?.gm) * 100
          ) {
            item.goLivelineGreen =
              Number(res?.finalData?.preAndPostGoLiveData?.post?.gm) * 100;
            item.goLivelineRed = null;
          } else {
            item.goLivelineRed =
              Number(res?.finalData?.preAndPostGoLiveData?.post?.gm) * 100;
            item.goLivelineGreen = null;
          }
        }
        if (
          item.monthStartDate ==
          moment
            .utc(res?.finalData?.preAndPostGoLiveData?.pre?.goLiveDate)
            .format(`MMM'YY`)
        ) {
          flag = 1;
          if (
            Number(res?.finalData?.preAndPostGoLiveData?.pre?.gm) * 100 <=
            Number(res?.finalData?.preAndPostGoLiveData?.post?.gm) * 100
          ) {
            item.goLivelineGreen =
              Number(res?.finalData?.preAndPostGoLiveData?.post?.gm) * 100;
            item.goLivelineRed = null;
          } else {
            item.goLivelineRed =
              Number(res?.finalData?.preAndPostGoLiveData?.post?.gm) * 100;
            item.goLivelineGreen = null;
          }
        }
      });
      setLineChartData(newData);
      setPrePostLiveData(res?.finalData?.preAndPostGoLiveData);
      let exportData: any = [];

      res?.finalData?.lineChart?.map((item: any) => {
        exportData.push({
          Category:
            payload.valueCapture_l3.length > 0
              ? payload.valueCapture_l3
              : "All",
          Supplier:
            payload.master_vendor_name.length > 0
              ? payload.master_vendor_name
              : "All",
          District: payload.district.length > 0 ? payload.district : "All",
          cost: `$${item.cost?.toFixed(2)}`,
          sales: `$${item.revenue?.toFixed(2)}`,
          month: moment.utc(item.monthStartDate).format(`MMM`),
          year: moment.utc(item.monthStartDate).format(`YYYY`),
          gm: `${(item.margin * 100)?.toFixed(2)}%`,
          marginWoLeakage: `${(item.marginWoLeakage * 100)?.toFixed(2)}%`,
          leakage: `$${item.leakage?.toFixed(2)}`,
          margin: `$${(item.marginBenefit || 0)?.toFixed(2)}`,
          netCostRed: `$${item.netCostRed?.toFixed(2)}`,
        });
      });

      setExport1Data(exportData);

      setLineChartDataCopy(newData);
      const values = newData.map((obj: any) => obj.margin);
      const gmvalues = newData.map((obj: any) => obj.gmLeakageLabel);
      const min = Math.min(...values); // 5
      const max = Math.max(...values); // 20
      const gmMax = Math.max(...gmvalues);
      setMinMax({
        min: Math.round(min),
        max: Math.round(max > gmMax ? max : gmMax),
      });
      let isPostGreater =
        res?.finalData?.preAndPostGoLiveData?.pre?.gm <=
        res?.finalData?.preAndPostGoLiveData?.post?.gm
          ? true
          : false;
      setMarginfBelowRef(
        (selectedTimeline == "preGoLive"
          ? isPostGreater
            ? 0
            : 100
          : res?.finalData[selectedTimeline]?.gm * 100) >
          newData[newData?.length - 1]?.margin
          ? true
          : false
      );

      let obj: any = [],
        positive = 0,
        negative = 0;

      if (selectedTimeline === "preGoLive") {
        positive =
          res?.finalData?.preAndPostGoLiveData?.post?.gm * 100 -
          res?.finalData?.preAndPostGoLiveData?.pre?.gm * 100;
        negative =
          newData[newData?.length - 1]?.gmLeakageLabel -
          res?.finalData?.preAndPostGoLiveData?.post?.gm * 100;
        if (isPostGreater) {
          obj = [
            {
              name: "A",
              uv: res?.finalData?.preAndPostGoLiveData?.pre?.gm * 100,
              pv: 2,
            },
            {
              name: "A",
              uv: res?.finalData?.preAndPostGoLiveData?.post?.gm * 100 - 0.04,
              pv: 2,
            },
            {
              name: "A",
              uv: res?.finalData?.preAndPostGoLiveData?.post?.gm * 100 + 0.04,
              pv: 2,
            },
            {
              name: "A",
              uv: newData[newData?.length - 1]?.gmLeakageLabel - 0.1,
              // lv:25,
              pv: 2,
            },
          ];
        } else {
          obj = [
            {
              name: "A",
              uv: newData[newData?.length - 1]?.margin,
              pv: 2,
            },
            {
              name: "A",
              uv: res?.finalData?.preAndPostGoLiveData?.post?.gm * 100 - 0.04,
              pv: 2,
            },
            {
              name: "A",
              uv: res?.finalData?.preAndPostGoLiveData?.post?.gm * 100 + 0.04,
              pv: 2,
            },
            {
              name: "A",
              uv: newData[newData?.length - 1]?.gmLeakageLabel - 0.1,
              // lv:25,
              pv: 2,
            },
          ];
        }
      } else {
        positive =
          newData[newData?.length - 1]?.margin -
          res?.finalData[selectedTimeline]?.gm * 100;
        negative =
          newData[newData?.length - 1]?.gmLeakageLabel -
          newData[newData?.length - 1]?.margin;
        obj = [
          {
            name: "A",
            uv: res?.finalData[selectedTimeline]?.gm * 100,
            pv: 2,
          },
          {
            name: "A",
            uv: newData[newData?.length - 1]?.margin - 0.04,
            pv: 2,
          },
          {
            name: "A",
            uv: newData[newData?.length - 1]?.margin + 0.04,
            pv: 2,
          },
          {
            name: "A",
            uv: newData[newData?.length - 1]?.gmLeakageLabel - 0.1,
            // lv:25,
            pv: 2,
          },
        ];
      }
      setBpsGraphData(obj);

      setBpsData({
        positive: positive,
        negative: negative,
      });
    }
    setIsLoading(false);
  };

  console.log(bpsData, "bpsdata");

  useEffect(() => {
    let isPostGreater =
      prePostLiveData?.pre?.gm <= prePostLiveData?.post?.gm ? true : false;
    setMarginfBelowRef(
      (selectedTimeline == "preGoLive"
        ? isPostGreater
          ? 0
          : 100
        : overviewData[selectedTimeline]?.gm * 100) >
        lineChartData[lineChartData?.length - 1]?.margin
        ? true
        : false
    );

    let obj: any = [],
      positive = 0,
      negative = 0;

    if (selectedTimeline === "preGoLive") {
      positive =
        prePostLiveData?.post?.gm * 100 - prePostLiveData?.pre?.gm * 100;
      negative =
        lineChartData[lineChartData?.length - 1]?.gmLeakageLabel -
        prePostLiveData?.post?.gm * 100;
      if (isPostGreater) {
        obj = [
          {
            name: "A",
            uv: prePostLiveData?.pre?.gm * 100,
            pv: 2,
          },
          {
            name: "A",
            uv: prePostLiveData?.post?.gm * 100 - 0.04,
            pv: 2,
          },
          {
            name: "A",
            uv: prePostLiveData?.post?.gm * 100 + 0.04,
            pv: 2,
          },
          {
            name: "A",
            uv: lineChartData[lineChartData?.length - 1]?.gmLeakageLabel - 0.1,
            // lv:25,
            pv: 2,
          },
        ];
      } else {
        obj = [
          {
            name: "A",
            uv: lineChartData[lineChartData?.length - 1]?.margin,
            pv: 2,
          },
          {
            name: "A",
            uv: prePostLiveData?.post?.gm * 100 - 0.04,
            pv: 2,
          },
          {
            name: "A",
            uv: prePostLiveData?.post?.gm * 100 + 0.04,
            pv: 2,
          },
          {
            name: "A",
            uv: lineChartData[lineChartData?.length - 1]?.gmLeakageLabel - 0.1,
            // lv:25,
            pv: 2,
          },
        ];
      }
    } else {
      positive =
        lineChartData[lineChartData?.length - 1]?.margin -
        overviewData[selectedTimeline]?.gm * 100;
      negative =
        lineChartData[lineChartData?.length - 1]?.gmLeakageLabel -
        lineChartData[lineChartData?.length - 1]?.margin;
      obj = [
        {
          name: "A",
          uv: overviewData[selectedTimeline]?.gm * 100,
          pv: 2,
        },
        {
          name: "A",
          uv: lineChartData[lineChartData?.length - 1]?.margin - 0.04,
          pv: 2,
        },
        {
          name: "A",
          uv: lineChartData[lineChartData?.length - 1]?.margin + 0.04,
          pv: 2,
        },
        {
          name: "A",
          uv: lineChartData[lineChartData?.length - 1]?.gmLeakageLabel - 0.1,
          // lv:25,
          pv: 2,
        },
      ];
    }
    setBpsGraphData(obj);

    setBpsData({
      positive: positive,
      negative: negative,
    });

    let chartCopyData = JSON.parse(JSON.stringify(lineChartDataCopy));
    let lastItems = [];
    if (selectedTimeline === "last3Months") {
      lastItems = chartCopyData?.slice(-4);
      setLineChartData(lastItems);
    } else if (selectedTimeline === "last6Months") {
      lastItems = chartCopyData?.slice(-7);
      setLineChartData(lastItems);
    } else if (selectedTimeline === "last12Months") {
      lastItems = chartCopyData?.slice(-13);
      setLineChartData(lastItems);
    } else {
      setLineChartData(chartCopyData);
    }
  }, [selectedTimeline]);

  

  useEffect(()=>{
    if(didMount?.current){
      if(timelineObject?.baseline&&timelineObject.current){
        getGraphData()
        getGraphDataSet2()
      }
    }else{
      didMount.current=true
    }
  },[timelineObject,didMount])

  const getGraphData = async (
    clearFilterFlag: any = null,
    filterSelected: any = null
  ) => {
    let payload: any = {
      district: selectedFilters.district,
      valueCapture_l3: selectedFilters.valueCapture_l3,
      master_vendor_name: selectedFilters.supplier,
      baseline: timelineObject?.baseline,
      current: timelineObject?.current,
    };
    if (clearFilterFlag == "valueCapture_l3") {
      payload.valueCapture_l3 = [];
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (clearFilterFlag == "supplier") {
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (clearFilterFlag == "district") {
      payload.district = [];
    }

    if (filterSelected == "valueCapture_l3") {
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (filterSelected == "supplier") {
      payload.district = [];
    }

    let res = await dispatch(getValueCaptureGraphData(payload));

    setGraphData(res.data);
    // setGoLiveDate(res.goliveDate);
    // setIsGraphLoading(false);
  };

  const getGraphDataSet2 = async (
    clearFilterFlag: any = null,
    filterSelected: any = null
  ) => {
    let payload: any = {
      district: selectedFilters.district,
      valueCapture_l3: selectedFilters.valueCapture_l3,
      master_vendor_name: selectedFilters.supplier,
      baseline: timelineObject?.baseline,
      current: timelineObject?.current,
    };

    if (clearFilterFlag == "valueCapture_l3") {
      payload.valueCapture_l3 = [];
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (clearFilterFlag == "supplier") {
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (clearFilterFlag == "district") {
      payload.district = [];
    }

    if (filterSelected == "valueCapture_l3") {
      payload.master_vendor_name = [];
      payload.district = [];
    } else if (filterSelected == "supplier") {
      payload.district = [];
    }

    let res = await dispatch(getValueCaptureMarginGraphData(payload));

    setGraphData2(res);
    // setIsGraph2Loading(false);
  };

  const getFilterSelected = () => {
    let temp = "";

    selectedFilters.valueCapture_l3.length > 0 &&
      selectedFilters.valueCapture_l3.map((item: any, i: any) => {
        temp = temp + " " + item + ",";
      });
    selectedFilters.supplier.length > 0 &&
      selectedFilters.supplier.map((item: any, i: any) => {
        temp = temp + " " + item + ",";
      });
    selectedFilters.district.length > 0 &&
      selectedFilters.district.map((item: any, i: any) => {
        temp = temp + " " + item + ",";
      });

    return selectedFilters.valueCapture_l3.length > 0 ||
      selectedFilters.supplier.length > 0 ||
      selectedFilters.district.length > 0
      ? temp
      : "Overall";
  };

  const timelineHandler = (e: any) => {
    setSelectedTimeline(e === null ? "All" : e);
  };

  const customTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="custom-tooltip">
          <p className="label" style={{ padding: "0", margin: "0" }}>
            <label
              style={{
                color: "#C8C8C8",
                fontSize: "10px",
                fontWeight: "normal",
              }}
            >
              Date :{" "}
            </label>
            <label
              style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}
            >
              {data.monthStartDate}
            </label>
          </p>
          <p className="label" style={{ padding: "0", margin: "0" }}>
            <label
              style={{
                color: "#C8C8C8",
                fontSize: "10px",
                fontWeight: "normal",
              }}
            >
              Gross Margin :{" "}
            </label>
            <label
              style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}
            >
              {numberFormatter(data.margin, 2)}%
            </label>
          </p>
        </div>
      );
    }
  };

  const getcardItemValue = (item: any, chartData: any, graphData: any) => {
    let cardValue: any = "222";
    if (item == "REALISED BENEFITS") {
      cardValue = numberFormatter(
        chartData?.calculationData?.actualized,
        2,
        "$"
      );
    } else if (item == "PROJECTED ANNUAL BENEFITS") {
      cardValue = numberFormatter(
        chartData?.graph2[chartData?.graph2.length - 1]
          .projectedSalesCumilative +
          chartData?.graph2[chartData?.graph2.length - 1]
            .incrementalNIAEstimate,
        2,
        "$"
      );
    } else if (item == "SALES") {
      let totalSales2025: any = 0;
      let totalSales2024: any = 0;
      graphData?.finalData.map((item: any) => {
        totalSales2025 = totalSales2025 + item.revenue_Curr;
        totalSales2024 = totalSales2024 + item.revenue_Prev;
      });
      let diff = totalSales2025 - totalSales2024;
      let percent = ((totalSales2025 - totalSales2024) / totalSales2024) * 100;
      cardValue =
        numberFormatter(totalSales2025, 2, "$") +
        "_" +
        numberFormatter(diff, 1, "$") +
        "_" +
        numberFormatter(percent, 1) +
        "_" +
        (diff > 0 ? "positive" : "negative");
    } else if (item == "NIA IMPROVEMENT") {
      let lastValueIndex = 0;
      chartData?.graph2?.map((item: any, index: any) => {
        if (item.monthlyRev != 0) {
          lastValueIndex = index;
        }
      });

      cardValue = numberFormatter(
        chartData?.graph2[lastValueIndex].incrementalNIAEstimate,
        2,
        "$"
      );
    }
    return cardValue;
  };

  const exportExcelHandler = async () => {
    toaster.push(message, { placement: "topCenter" });
    let payload = {
      district: selectedFilters.district,
      valueCapture_l3: selectedFilters.valueCapture_l3,
      master_vendor_name: selectedFilters.supplier,
      implemented: false,
    };
    let res = await dispatch(getValueCaptureExportData(payload));
    res.data.map((item: any) => {
      item.gm2024 = item.gm2024 ? `${(item.gm2024 * 100)?.toFixed(2)}%` : 0;
      item.gm2025 = item.gm2025 ? `${(item.gm2025 * 100)?.toFixed(2)}%` : 0;
      item.costperunit2024 = `$${item.costperunit2024?.toFixed(2)}`;
      item.costperunit2025 = `$${item.costperunit2025?.toFixed(2)}`;
      item.netcost2024 = `$${item.netcost2024?.toFixed(0)}`;
      item.netcost2025 = `$${item.netcost2025?.toFixed(0)}`;
      item.sellpriceperunit2024 = `$${item.sellpriceperunit2024?.toFixed(2)}`;
      item.sellpriceperunit2025 = `$${item.sellpriceperunit2025?.toFixed(2)}`;
      item.revenue2025 = `$${item.revenue2025?.toFixed(0)}`;
      item.golive_date = moment.utc(item.golive_date).format("YYYY-MM-DD");
      item.week_start_month = moment
        .utc(item.week_start_month)
        .format("YYYY-MM-DD");
      item.marginRevenue = `$${item?.marginRevenue || 0}`;
      item.marginWoLeakage = `${(item.gmWoLeakage * 100)?.toFixed(2)}%`;
      item.leakage = `$${item.leakage?.toFixed(2)}`;
      item.margin = `$${(item.marginBenifit || 0)?.toFixed(2)}`;
      item.netCostRed = `$${item.netCostReduction?.toFixed(2)}`;
    });

    setExport2Data(res.data);
  };

  const pricingReportHandler = async () => {
    toaster.push(message, { placement: "topCenter" });
    let payload: any = {
      district: selectedFilters.district,
      valueCapture_l3: selectedFilters.valueCapture_l3,
      master_vendor_name: selectedFilters.supplier,
      implemented: true,
      from: moment(fromDate[0]).format("YYYY-MM-DD"),
    };
    if (toDate) {
      payload.to = moment(toDate[0]).format("YYYY-MM-DD");
    }

    let res = await dispatch(getValueCaptureExportData(payload));
    console.log("%%%", res);
    setToDate(null);
    setFromDate(null);
    res.data.map((item: any) => {
      item.weekOfYear = moment.utc(item.weekOfYear).format("YYYY-MM-DD");
      item.daydate = moment.utc(item.daydate).format("YYYY-MM-DD");
      item.GM = `${(item.GM * 100)?.toFixed(2)}%`;
      item.FLOOR_GMR = `${
        item.FLOOR_GMR == "NA"
          ? ""
          : `${Number(item.FLOOR_GMR * 100)?.toFixed(2)}%`
      }`;
      item.TARGET_GMR = `${
        item.TARGET_GMR == "NA"
          ? ""
          : `${Number(item.TARGET_GMR * 100)?.toFixed(2)}%`
      }`;
      item.Net_Cost_SPA_Adjusted_perUnit = `$${Number(
        item.Net_Cost_SPA_Adjusted_perUnit
      )?.toFixed(2)}`;
      item.Sell_Price_perUnit = `$${Number(item.Sell_Price_perUnit)?.toFixed(
        2
      )}`;
      item.targetPrice = `$${Number(item.targetPrice)?.toFixed(2)}`;
      item.FloorPrice = `$${Number(item.FloorPrice)?.toFixed(2)}`;
    });

    setPricingExportData(res.data);
  };

  const getFilteredOptions = (filterEntity: any) => {
    if (filterEntity === "valueCapture_l3") {
      if (activeTab === "margin") {
        return filterOptions[filterEntity].filter(
          (option: any) => option.valueCapture_l3 !== "Others (Eaton Specific)"
        );
      }
    }
    return filterOptions[filterEntity];
  };

  useEffect(() => {
    if (
      selectedFilters.valueCapture_l3?.includes("Fittings and Connectors") &&
      selectedFilters.supplier?.length === 0
    ) {
      setShowProjectedYear(true);
    } else if (
      selectedFilters.valueCapture_l3?.includes("Fittings and Connectors") &&
      selectedFilters.supplier?.length !== 0 &&
      selectedFilters.supplier?.includes(`BRIDGEPORT FITTINGS, INC.`)
    ) {
      setShowProjectedYear(true);
    } else if (
      selectedFilters.valueCapture_l3?.length === 0 &&
      selectedFilters.supplier?.includes(`BRIDGEPORT FITTINGS, INC.`)
    ) {
      setShowProjectedYear(true);
    } else if (
      selectedFilters.valueCapture_l3?.length === 0 &&
      selectedFilters.supplier?.length === 0
    ) {
      setShowProjectedYear(true);
    } else {
      setShowProjectedYear(false);
    }
  }, [selectedFilters]);

  console.log(lineChartData,"lineChartData")

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Modal
        onClose={() => handlePopUpClose()}
        backdrop={true}
        role="alertdialog"
        open={popUp}
        size="xs"
      >
        <Modal.Header closeButton={false}>
          <div className="flex">
            <div className="text-center text-[2.5vh] ml-[4vh] w-full mb-[1vh]">
              Pricing Export
            </div>

            <Button
              onClick={handlePopUpClose}
              style={{ background: "#941c14" }}
              className="modal-close-btn h-[4vh]"
            >
              Close
            </Button>
          </div>
          <p className="text-black text-center  mt-[4vh] text-[1.7vh] font-[400]">
            *Please filter at least one of category/supplier/district to
            generate export
          </p>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center gap-x-[7vh]">
            <div className="flex flex-col" style={{ maxWidth: "14vw" }}>
              <span className="capitalize">From</span>
              {/* <DatePicker value={fromDate} onChange={()=>setFromDate} oneTap placeholder="Select Date" style={{ width: 200 }} /> */}
              <DateRangePicker
                value={fromDate}
                onChange={(val: any) => {
                  setFromDate(val);
                  console.log(fromDate);
                }}
                hoverRange="week"
                placeholder="Select Date"
                showOneCalendar
                oneTap
                weekStart={1}
                ranges={[]}
                block
                style={{ width: '100%' }}
                menuStyle={{ minWidth: 420 }}   // adjust as needed
                container={() => document.body}
              />
            </div>
            <div className="flex flex-col" style={{ maxWidth: "14vw" }}>
              <span className="capitalize">To</span>
              {/* <DatePicker  value={toDate} onChange={()=>setToDate} oneTap placeholder="Select Date" style={{ width: 200 }} /> */}
              <DateRangePicker
                value={toDate}
                onChange={(val: any) => {
                  setToDate(val);
                }}
                shouldDisableDate={shouldDisableDate}
                hoverRange="week"
                placeholder="Select Date"
                showOneCalendar
                oneTap
                weekStart={1}
                ranges={[]}
              />
            </div>
          </div>
          <p className="text-[#40a108] text-center italic mt-[4vh] textSmall font-[400]">
            *You can download weekly data or at most 5 weeks of data. Select
            week start date in 'From' for one week. <br />
            Select week start date in both 'From' and 'To' for multiple weeks.
          </p>
        </Modal.Body>
        <Modal.Footer className="scenario-modal-footer">
          <Button onClick={handlePopUpConfirmClick} className="modal-save-btn">
            Download Export
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="marginPresevation-container">
        <MainHeader
          onVisibilityChange={setIsVisible}
          isRightVisible={isRightVisible}
          setIsRightVisible={setIsRightVisible}
          topContent={
            <>
              {/* Top Row: Heading (left) and Breadcrumbs (right) */}
              <div className="flex justify-between items-center w-full">
                {/* Heading */}
                <div className="text-left pageline  min-w-0">
                  <span className="pagelinestart truncate">Value Tracking</span>
                  <span className="pagelineslash">/</span>
                  <span className="pagelinesub truncate">
                    Margin Preservation Dashboard
                  </span>
                </div>
              </div>

              {/* View By Segment */}
              <div className="execution-level-wrapper">
                <div className="execution-level-title">View By</div>
                <Segmented
                  options={[
                    {
                      label: "Margin Improvement Overview",
                      value: "margin",
                    },
                    {
                      label: "Implemented SKUs",
                      value: "implemented",
                    },
                  ]}
                  value={activeTab}
                  onChange={setActiveTab}
                />
                {activeTab == "margin" ? (
                  <div className="filter-flex border-1 max-w-fit">
                    <div className="flex justify-center items-center h-full">
                      <Button
                        className="bg-transparent hover:bg-transparent"
                        onClick={exportDataClick}
                      >
                        <FileDownloadIcon
                          color="black"
                          className="text-fsre16"
                        />
                      </Button>
                    </div>
                    <CSVLink
                      ref={exportFullRef}
                      data={export1Data}
                      headers={csvHeaders}
                      filename="margin_improvement.csv"
                      className="hidden"
                      target="_blank"
                    >
                      {" "}
                    </CSVLink>
                  </div>
                ) : (
                  <div className="filter-flex border-1 max-w-fit">
                    {/* <div className="flex justify-center items-center h-full">
										<Button
											className="bg-transparent hover:bg-transparent"
											onClick={exportExcelHandler}
										>
											<FileDownloadIcon
												color="black"
												className="text-fsre16"
											/>
										</Button>
									</div> */}
                    <CSVLink
                      ref={exportFullRef2}
                      data={export2Data}
                      headers={csvHeaders2}
                      filename="implemented_skus.csv"
                      className="hidden"
                      target="_blank"
                    >
                      {" "}
                    </CSVLink>
                    <div className="flex justify-center items-center h-full">
                      {/* <Button
											className="bg-transparent hover:bg-transparent"
											onClick={()=>{
												if(selectedFilters.valueCapture_l3.length == 1){
												setPopUp(true)
												} else{
												toaster.push(message2, { placement: "topCenter" });
												}
											}}
										>
											<FileDownloadIcon
												color="black"
												className="text-fsre16"
											/>
										</Button> */}
                      <CSVLink
                        ref={exportFullRef3}
                        data={pricingExportData}
                        headers={csvHeaders3}
                        filename="pricing_report.csv"
                        className="hidden"
                        target="_blank"
                      >
                        {" "}
                      </CSVLink>
                    </div>

                    <div
                      className={`min-w-[2vw] flex justify-start items-center gap-0.2 cursor-pointer px-[1.2vh] py-[1vh] relative`}
                    >
                      <div
                        className="flex justify-between w-full"
                        onClick={() => {
                          setIsOpen(!isOpen);
                        }}
                      >
                        <FileDownloadIcon
                          color="black"
                          className="text-fsre16"
                        />

                        <img
                          className={` arrow exportArrow ml-2  ${
                            isOpen ? "rotate-180" : ""
                          }`}
                          src={GreenUpArrow}
                          alt="Dropdown"
                        />
                      </div>
                      <div className="z-[9999] hidden"></div>
                      {isOpen && (
                        <div className="absolute top-[100%] right-[10%] w-full translate-y-[3px] m-auto z-[10000] min-w-[18vh]">
                          <ul>
                            {["Export Excel", "Pricing Report"].map(
                              (subMenu) => (
                                <li
                                  key={subMenu}
                                  className={`flex items-center p-[7px] border-[1px] bg-white justify-between`}
                                  onClick={() => {
                                    if (subMenu == "Export Excel") {
                                      exportExcelHandler();
                                    } else {
                                      if (
                                        selectedFilters.valueCapture_l3
                                          .length == 1
                                      ) {
                                        setPopUp(true);
                                      } else {
                                        toaster.push(message2, {
                                          placement: "topCenter",
                                        });
                                      }
                                    }
                                    setIsOpen(false);
                                  }}
                                >
                                  <span className="submenu-title min-w-[10vh]">
                                    {subMenu}
                                  </span>
                                  <FileDownloadIcon
                                    color="black"
                                    className="text-fsre16"
                                  />
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          }
          bottomContent={
            <>
              {["valueCapture_l3", "supplier", "district"].map(
                (filterEntity: string, index: number) => {
                  return (
                    <div
                      className="sub-heading-text font-bold flex flex-col items-start"
                      style={{ maxWidth: "9vw" }}
                      key={filterEntity}
                    >
                      <span className="filterHead ">
                        {filterEntity == "valueCapture_l3"
                          ? "Category"
                          : filterEntity}
                      </span>
                      <CheckPicker
                        data={
                          getFilteredOptions(filterEntity).length
                            ? getFilteredOptions(filterEntity)
                            : []
                        }
                        placeholder="All"
                        labelKey={
                          filterEntity == "supplier"
                            ? "master_vendor_name"
                            : filterEntity
                        }
                        valueKey={
                          filterEntity == "supplier"
                            ? "master_vendor_name"
                            : filterEntity
                        }
                        placement={
                          filterEntity == "district"
                            ? "bottomEnd"
                            : "bottomStart"
                        }
                        value={
                          selectedFilters[filterEntity]
                            ? selectedFilters[filterEntity]
                            : []
                        }
                        onClose={() =>
                          filtersMount.current ? handleClose(filterEntity) : ""
                        }
                        onClean={() => {
                          handleClear(filterEntity);
                        }}
                        onChange={(value: any) =>
                          handleFilterUpdate(value, filterEntity)
                        }
                        loading={filtersLoading}
                        renderExtraFooter={() => (
                          <div
                            style={{
                              padding: "10px 2px",
                              borderTop: "1px solid #e5e5e5",
                            }}
                          >
                            <Checkbox
                              indeterminate={
                                selectedFilters[filterEntity].length > 0 &&
                                selectedFilters[filterEntity].length <
                                  filterOptions[filterEntity].length
                              }
                              checked={
                                selectedFilters[filterEntity].length ===
                                filterOptions[filterEntity].length
                              }
                              onChange={(value: any) =>
                                handleFilterUpdate("all", filterEntity)
                              }
                            >
                              Check all
                            </Checkbox>
                          </div>
                        )}
                      />
                    </div>
                  );
                }
              )}
            </>
          }
        ></MainHeader>
        <MainContent isVisible={isVisible} fullHeight={true}>
          <div
            className={`chart-flex h-[100%] contentBox ${
              activeTab == "margin" ? "px-[7vh]" : "px-[2vh]"
            }`}
          >
            {activeTab == "margin" ? (
              <div className="topSuppliers-container graphBox flex flex-col justify-start overflow-x-auto">
                <div className="headSpace !h-[10vh]">
                  <span className="headContent">
                    {getFilterSelected()} gross margin performance
                  </span>
                  <div
                    className="sub-heading-text font-bold flex flex-col items-start mb-[2vh]"
                    style={{ maxWidth: "9vw" }}
                  >
                    <span className="filterHead !mb-0 ">Timeline</span>
                    <SelectPicker
                      data={
                        leakageTimelineOptions.length
                          ? leakageTimelineOptions
                          : []
                      }
                      placeholder="All"
                      value={selectedTimeline}
                      defaultValue={
                        leakageTimelineOptions.length
                          ? leakageTimelineOptions[0].value
                          : ""
                      }
                      onChange={timelineHandler}
                      cleanable={false}
                      searchable={false}
                    />
                  </div>
                </div>
                {Object.keys(overviewData).length > 0 && (
                  <div className="flex h-full justify-center w-full">
                    <ResponsiveContainer
                      width="70%"
                      height="90%"
                      className=" pt-[0] "
                    >
                      <ComposedChart
                        data={lineChartData}
                        className="chartConatiner"
                        margin={{ top: 10,right:30 }}
                      >
                        <XAxis
                          dataKey="monthStartDate"
                          stroke="black"
                          fontSize="0.7vw"
                          interval={0}
                        >
                          <Label
                            value="Months"
                            offset={5}
                            fontSize={"1vw"}
                            position="bottom"
                            style={{ fill: "black" }}
                            dy={10}
                          />
                        </XAxis>
                        <YAxis
                          stroke="black"
                          fontSize="0.7vw"
                          tickFormatter={(value: number) =>
                            `${numberFormatter(value, 0)}%`
                          }
                          domain={[minMax.min - 1, minMax.max + 1]}
                        >
                          <Label
                            value="Gross Margin(%)"
                            angle={-90}
                            offset={2}
                            fontSize={"1vw"}
                            position="insideLeft"
                            style={{ fill: "black", textAnchor: "middle" }}
                            dx={-10}
                          />
                        </YAxis>

                        <ReferenceLine
                          y={overviewData[selectedTimeline]?.gm * 100}
                          stroke="#525252"
                          strokeDasharray="10 10"
                          opacity={0.8}
                        />

                        {overviewData.goLiveDate.map((item: any) => {
                          return (
                            <ReferenceLine
                              x={moment.utc(item.golive_date).format(`MMM'YY`)}
                              label={{
                                position: "top",
                                fill: "#78cecdff",
                                value: `${
                                  item.master_vendor_name ==
                                  "BRIDGEPORT FITTINGS, INC."
                                    ? "BP"
                                    : item.master_vendor_name ==
                                      "THOMAS & BETTS"
                                    ? "T&B"
                                    : item.master_vendor_name ===
                                      "HUBBELL WIRING DEVICE - KELLEMS"
                                    ? "HUBBELL KELLEMS"
                                    : item.master_vendor_name
                                } Go-Live`,
                                width: "20vh",
                                fontSize: "1.5vh",
                                fontWeight: "500",
                              }}
                              stroke="#78cecdff"
                              strokeDasharray="5 3"
                              opacity={0.8}
                            />
                          );
                        })}

                        <Tooltip
                          contentStyle={{
                            color: "white",
                            backgroundColor: "rgb(26, 25, 22)",
                          }}
                          cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
                          content={customTooltip}
                        />
                        <Legend
                          verticalAlign="top"
                          content={(props) =>
                            renderLegend({
                              ...props,
                              selectedTimeline,
                              overviewData,
                              prePostLiveData,
                            })
                          }
                        />

                        <Line
                          type="linear"
                          dataKey="margin"
                          name={``}
                          stroke="#050256ff"
                          strokeDasharray={"0"}
                          connectNulls={false}
                          strokeWidth={2}
                        >
                          <LabelList
                            dataKey="margin"
                            fill="black"
                            fontWeight={400}
                            fontSize="1.4vh"
                            formatter={(value: number) =>
                              value == 0
                                ? null
                                : `${numberFormatter(value, 1)}%`
                            }
                            position="insideTopLeft"
                          ></LabelList>
                        </Line>
                        {bpsData?.negative > 0 && (
                          <Scatter
                            dataKey="gmLeakageLabel"
                            fill="red"
                            legendType="none"
                          >
                            <LabelList
                              dataKey="gmLeakageLabel"
                              position="top"
                              content={<CustomLabel />}
                            />
                          </Scatter>
                        )}
                        {selectedTimeline == "preGoLive" && (
                          <>
                            <Line
                              type="linear"
                              dataKey="goLiveline1"
                              name={``}
                              stroke="#525252"
                              strokeDasharray="10 10"
                              connectNulls={false}
                              strokeWidth={2}
                              dot={false}
                            ></Line>
                            <Line
                              type="linear"
                              dataKey="goLivelineGreen"
                              name={``}
                              stroke="#1def36ff"
                              strokeDasharray="10 10"
                              connectNulls={false}
                              strokeWidth={2}
                              dot={false}
                            ></Line>
                            <Line
                              type="linear"
                              dataKey="goLivelineRed"
                              name={``}
                              stroke="#ef241dff"
                              strokeDasharray="10 10"
                              connectNulls={false}
                              strokeWidth={2}
                              dot={false}
                            ></Line>
                          </>
                        )}
                      </ComposedChart>
                    </ResponsiveContainer>

                    <ResponsiveContainer
                      width={65}
                      height="90%"
                      className="pt-[0]"
                    >
                      <LineChart
                        layout="vertical"
                        data={bpsGraphData}
                        margin={{
                          top: 50,
                          right: 30,
                          left: -20,
                          bottom: 0,
                        }}
                      >
                        <XAxis
                          type="number"
                          dataKey="pv"
                          axisLine={false}
                          tick={false}
                          tickLine={false}
                        />
                        <YAxis
                          reversed
                          domain={[minMax.min - 1, minMax.max + 1]}
                          dataKey="uv"
                          fontSize="1.5vh"
                          axisLine={false}
                          tick={false}
                          tickLine={false}
                          tickFormatter={(value: number) =>
                            `${numberFormatter(value, 2)}%`
                          }
                        />
                        {/* Line from point 1 to 2 */}
                        {!marginBelowRef && (
                          <Line
                            dataKey="uv"
                            data={bpsGraphData.slice(0, 2)}
                            stroke="green"
                            strokeWidth={4}
                            isAnimationActive={false}
                            connectNulls
                            dot={<ThinDot color={"green"} />}
                          >
                            <LabelList
                              content={
                                <CustomMiddleLabel
                                  marginBelowRef={marginBelowRef}
                                  isPositive={true}
                                  bpsData={bpsData}
                                  overviewData={overviewData}
                                  selectedTimeline={selectedTimeline}
                                />
                              }
                            />
                          </Line>
                        )}
                        {/* Line from point 2 to 3 */}
                        {bpsData?.negative > 0 && (
                          <Line
                            dataKey="uv"
                            data={bpsGraphData.slice(2, 4)}
                            stroke="red"
                            strokeWidth={4}
                            isAnimationActive={false}
                            connectNulls
                            dot={<ThinDot color={"red"} />}
                          >
                            <LabelList
                              content={
                                <CustomMiddleLabel
                                  marginBelowRef={false}
                                  isPositive={false}
                                  bpsData={bpsData}
                                  overviewData={overviewData}
                                  selectedTimeline={selectedTimeline}
                                />
                              }
                            />
                          </Line>
                        )}
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                )}
              </div>
            ) : (
              <div className="w-full flex gap-x-[1%]">
                <div
                  className={`flex flex-col ${
                    !isVisible ? "gap-[1vw]" : "gap-[.5vw]"
                  } w-[15%]`}
                >
                  {implementedTabs.map((item: any, idx: any) => (
                    <div
                      key={idx}
                      className={`flex-1 mpStatusCard bg-[#FFFFFF] text-black flex flex-col justify-start 
													${!isVisible ? "textMedium" : "textSmall"}
													`}
                      style={{ borderRadius: ".5vh" }}
                    >
                      <p className="m-[1vh] text-center font-bold border-b-[1px] border-[#00000036]">
                        {item}
                      </p>
                      <div className={`flex w-full pt-[.5vh]`}>
                        <div className="w-[100%] flex flex-col justify-center items-center gap-x-[1vh]">
                          <span>
                            {item === "PROJECTED ANNUAL BENEFITS"
                              ? "2025"
                              : "2025 YTD"}
                          </span>

                          <div className="font-bold bg-[#F2F4F7] p-[1vh] w-fit rounded-[.5vh] text-center">
                            {item === "SALES"
                              ? getcardItemValue(
                                  item,
                                  graphData2,
                                  graphData
                                ).split("_")[0]
                              : getcardItemValue(item, graphData2, graphData)}
                          </div>
                        </div>
                      </div>
                      {item === "SALES" && (
                        <div className="flex w-full justify-end">
                          <span
                            className="mr-[1.5vh]  font-bold"
                            style={{
                              color:
                                getcardItemValue(
                                  item,
                                  graphData2,
                                  graphData
                                ).split("_")[3] === "negative"
                                  ? "#d55454"
                                  : "#008b00",
                            }}
                          >
                            {getcardItemValue(
                              item,
                              graphData2,
                              graphData
                            ).split("_")[3] === "negative"
                              ? "-"
                              : "+"}
                            {
                              getcardItemValue(
                                item,
                                graphData2,
                                graphData
                              ).split("_")[1]
                            }
                            {` (${
                              getcardItemValue(
                                item,
                                graphData2,
                                graphData
                              ).split("_")[3] === "negative"
                                ? "-"
                                : ""
                            }${
                              getcardItemValue(
                                item,
                                graphData2,
                                graphData
                              ).split("_")[2]
                            }%)`}
                          </span>
                        </div>
                      )}
                      {item == "NIA IMPROVEMENT" && showProjectedYear && (
                        <div className="flex w-full justify-end">
                          <span
                            className={`mr-[1.5vh] text-[1.5vh] font-bold `}
                            style={{
                              color: "#008b00",
                            }}
                          >
                            684K projected by year end
                          </span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <div className={`h-[100%] flex flex-row w-full gap-x-2`}>
                  <div className="w-[55%]">
                    <MarginImprovement
                      isVisible={isVisible}
                      chartData={graphData2}
                      heading={"Margin Improvement"}
                      page={"summary"}
                      selectedTimeline={selectedTimeline}
                      getTimelineHandler={timelineHandler}
                      timelineHandler={(data)=>{
                        setTimelineObject(data)
                      }}
                      exportData={graphData}
                      timelineObject={timelineObject}
                    />
                  </div>
                  <div className="w-[45%] flex flex-col gap-y-[1%]">
                    <div className="w-full h-[50%]">
                      <NetCostReductionChart
                        chartData={graphData}
                        goLiveDate={goLiveDate}
                        heading={"Net Cost Reduction"}
                        page={"summary"}
                        isVisible={isVisible}
                        timelineObject={timelineObject}
                      />
                    </div>
                    <div className="w-full h-[50%]">
                      <PricingExecution
                        chartData={graphData}
                        heading={"Pricing Execution (Sell Price Index)"}
                        isVisible={isVisible}
                        timelineObject={timelineObject}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </MainContent>
      </div>
    </>
  );
};

const CustomMiddleLabel = (props: any) => {
  const {
    isPositive,
    overviewData,
    selectedTimeline,
    marginBelowRef,
    bpsData,
  } = props;

  const yHeight = bpsData?.negative * 100 < 100 ? -10 : 15;
  const textYHeight = bpsData?.negative * 100 < 100 ? 5 : 30;

  const pyHeight = marginBelowRef ? -20 : 15;
  const ptextYHeight = marginBelowRef ? -5 : 30;

  if (props.index !== 1) return null;
  // Offset label to the right (increase x)
  return (
    <>
      {isPositive && (
        <>
          <text
            x={props.x + 30} // shift right by 30px
            y={props.y + pyHeight}
            fill={isPositive ? "green" : "red"}
            fontSize={12}
            alignmentBaseline="middle"
          >
            +{numberFormatter(bpsData?.positive * 100, 0)} BPS
          </text>{" "}
          <text
            x={props.x + 30} // shift right by 30px
            y={props.y + ptextYHeight}
            fill={isPositive ? "green" : "red"}
            fontSize={11}
          >
            Margin Improvement
          </text>
        </>
      )}
      {!isPositive && (
        <>
          <text
            x={props.x + 30} // shift right by 30px
            y={props.y + yHeight}
            fill={isPositive ? "green" : "red"}
            fontSize={12}
            alignmentBaseline="middle"
          >
            {numberFormatter(bpsData?.negative * 100, 0)} BPS
          </text>
          <text
            x={props.x + 30} // shift right by 30px
            y={props.y + textYHeight}
            fill={isPositive ? "green" : "red"}
            fontSize={11}
          >
            Margin leakage
          </text>
        </>
      )}
    </>
  );
};

const ThinDot = (props: any) => {
  const {
    cx,
    cy,
    stroke = "#8884d8",
    width = 12,
    strokeWidth = 2,
    color,
  } = props;
  // Draw a horizontal line centered at (cx, cy)
  // Define the length of the horizontal line (e.g., 20 pixels wide)
  const lineLength = 10; // Half of the total width (extends 10px left and right)
  return (
    <line
      x1={cx - lineLength}
      y1={cy}
      x2={cx + lineLength}
      y2={cy}
      stroke={color} // Color of the line (match or customize as needed)
      strokeWidth={2} // Thickness of the line
    />
  );
};

const renderLegend = (props: any) => {
  const { payload, selectedTimeline, overviewData, prePostLiveData } = props;
  return (
    <div className="w-full flex justify-start">
      <span className="text-[#525252] text-center w-[15vw] flex items-center text-[1.5vh] font-bold ml-[5vw] mb-[2vw]">
        <svg width="12%" className="mr-2" height="8">
          <rect x="0" y="0" width="100%" height="8" fill="white" />
          <line
            x1="0"
            y1="4"
            x2="100%"
            y2="4"
            stroke="#525252"
            stroke-width="1"
            stroke-dasharray="10,10"
          />
        </svg>{" "}
        Avg. GM for{" "}
        {selectedTimeline == "preGoLive"
          ? "Pre Go Live"
          : selectedTimeline == "last6Months"
          ? "Last 6 Months"
          : selectedTimeline == "lastYear"
          ? "Last Year"
          : selectedTimeline == "last1Months"
          ? "Last Month"
          : selectedTimeline == "last3Months"
          ? "Last 3 Months"
          : selectedTimeline == "last4Months"
          ? "Last 4 Months"
          : "Last 12 Months"}
        :{" "}
        {selectedTimeline == "preGoLive"
          ? numberFormatter(prePostLiveData?.pre?.gm * 100, 2)
          : numberFormatter(overviewData[selectedTimeline]?.gm * 100, 2)}
        %
      </span>
      {selectedTimeline == "preGoLive" && (
        <span
          className={`${
            prePostLiveData?.pre?.gm <= prePostLiveData?.post?.gm
              ? "text-[#1bce30ff]"
              : "text-[#ef241dff]"
          } text-center w-[15vw] flex items-center text-[1.5vh] font-bold mb-[2vw]`}
        >
          <svg width="12%" className="mr-2" height="8">
            <rect x="0" y="0" width="100%" height="8" fill="white" />
            <line
              x1="0"
              y1="4"
              x2="100%"
              y2="4"
              stroke={
                prePostLiveData?.pre?.gm <= prePostLiveData?.post?.gm
                  ? "#1def36ff"
                  : "#ef241dff"
              }
              stroke-width="1"
              stroke-dasharray="10,10"
            />
          </svg>{" "}
          Avg. GM for Post Go Live:{" "}
          {numberFormatter(prePostLiveData?.post?.gm * 100, 2)}%
        </span>
      )}
    </div>
  );
};

const CustomLabel = (props: any) => {
  const { x, y, value } = props;
  const [offsetX, setOffsetX] = useState(0);

  useEffect(() => {
    function handleResize() {
      // Example: offset is 10% of window width
      const dynamicOffset = window.innerWidth / 35;
      setOffsetX(dynamicOffset);
    }

    // Initial call
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <g transform={`translate(${x - offsetX}, ${y - 8})`}>
      {value && (
        <text>
          <tspan x={0} dy={0} fontSize="1.2vh" fontWeight={600} fill="black">
            GM% wo Leakage:
          </tspan>
          <tspan x={0} dy="2vh" fontSize="1.7vh" fontWeight="bold" fill="black">
            {`${numberFormatter(value, 1)}%`}
          </tspan>
        </text>
      )}
    </g>
  );
};

const message = (
  <Notification type={"info"} header={`Exporting...`} closable>
    <p>
      Your file is being created. It will be download automatically. Please dont
      press back
    </p>
  </Notification>
);

const message2 = (
  <Notification type={"info"} header={`Please select atmost 1 l3`} closable>
    <p>Please select atmost one category for the pricing report export.</p>
  </Notification>
);

export default MarginPreservationDashboard;
